
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = "https://plilqpzezqaulvaswuza.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBsaWxxcHplenFhdWx2YXN3dXphIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU3MjkyNDQsImV4cCI6MjA2MTMwNTI0NH0.4s0gMMWu5kJhgeptce4ORyY9WD7S8KfGUHpogth6cxw";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true
  }
});
